module.exports = __webpack_public_path__ + "static/media/header_cards.03c2e5dc.jpg";